// extracted by css-extract-rspack-plugin
export default {"newPrice":"newPrice-nE4aHX","negativePrice":"negativePrice-loNT71"};